import {
  HIWContainer,
  Header,
  HIWWrapper,
  Column1,
  Column2,
  Column3,
  ColunmHeader,
  ColunmSubHeader,
  ColunmParagraph,
} from "./HowItWorksElements";

const HowItWorksSection = () => {
    return (
      <>
        <HIWWrapper id="Howitworks">
          <Header>How it works</Header>

          <HIWContainer>
            <Column1>
              <ColunmHeader>Step 1</ColunmHeader>
              <ColunmSubHeader>Sign up</ColunmSubHeader>
              <ColunmParagraph>
                Download our App or sign up online. Top up on your Paythumb
                wallet using Mobile Money.
              </ColunmParagraph>
            </Column1>
            <Column2>
              <ColunmHeader>Step 2</ColunmHeader>
              <ColunmSubHeader>Enroll your fingerprint</ColunmSubHeader>
              <ColunmParagraph>
                Visit our nearby enrollment centers and link your fingerprint to
                your account.
              </ColunmParagraph>
            </Column2>
            <Column3>
              <ColunmHeader>Step 3</ColunmHeader>
              <ColunmSubHeader>Start spending</ColunmSubHeader>
              <ColunmParagraph>
                Just tap and go with your fingerprint wherever Paythumb is
                accepted.
              </ColunmParagraph>
            </Column3>
          </HIWContainer>
        </HIWWrapper>
      </>
    );
}

export default HowItWorksSection
